import React from 'react';
import styled from 'styled-components';
import { colors, weights } from '~/styles';

const SUGGESTIONS = [
  'Summarize my time entries for this week',
  'How many hours did I log last month?',
  'List my time entries for today',
  'Show my billable vs non-billable hours this month',
  'Show my time entries from last week',
  "What's my billable hours ratio this month?",
  'How does my time this week compare to last week?',
  "What's my average daily hours this week?",
  'Which days did I miss logging time this month?',
  'Break down my time by task this week',
  'Show my non-billable hours this month',
  'Show me what I worked on yesterday',
  "What's my time breakdown by project this month?",
  'How many hours did I bill last quarter?',
  'Show my hours by client this month',
  'Show my expense items from this month',
  'Summarize my expenses for this quarter',
  'What did I expense last month?',
  'How much did I expense this year?',
  'Summarize my expenses by category this quarter',
  "List expense reports I've submitted this month",
  'List all my active projects',
  'Which projects did I work on this week?',
  'What projects have I logged time to this quarter?',
  'What tasks are assigned to me?',
  'Show me all clients in the workspace',
  'List all projects for a specific client',
  'Who are the members on my team?',
  'Show contacts for my clients',
  'What expense categories have I used this year?',
];

const S = {
  Row: styled.div`
    display: flex;
    gap: 0.375rem;
    padding: 0 0.25rem 0.8125rem;
    flex-wrap: wrap;
  `,

  Pill: styled.button`
    border: 1px dashed ${colors.grey10};
    border-radius: 999rem;
    background: transparent;
    color: ${colors.grey75};
    font-weight: ${weights.medium};
    font-size: 0.75rem;
    padding: 0.375rem 0.625rem;
    cursor: pointer;
    white-space: nowrap;
    height: auto;

    &:hover {
      background: ${colors.grey5};
      color: ${colors.grey75};
    }
  `,
};

export default function Suggestions({ conversationId, onSend }) {
  const shuffled = React.useMemo(() => {
    void conversationId; // reshuffle when conversation changes
    return [...SUGGESTIONS].sort(() => Math.random() - 0.5).slice(0, 5);
  }, [conversationId]);

  return (
    <S.Row>
      {shuffled.map((s) => (
        <S.Pill key={s} onClick={() => onSend(s)}>
          {s}
        </S.Pill>
      ))}
    </S.Row>
  );
}
